<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.5 12L0 8.50004L0.705 7.79504L3.5 10.585L6.295 7.79504L7 8.50004L3.5 12Z" fill="#93939F"/>
<path d="M3.5 0L7 3.5L6.295 4.205L3.5 1.415L0.705 4.205L0 3.5L3.5 0Z" fill="#93939F"/>
</svg>
